export const isMacOS = () => /Macintosh|MacIntel/.test(navigator.userAgent);
